export default __webpack_public_path__ + "static/media/i2.f77a6014.jpg";